/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NDataDto } from '../../models/i-18-n-data-dto';

export interface I18NGetI18NData$Params {
  'x-trace-id'?: string;
}

export function i18NGetI18NData(http: HttpClient, rootUrl: string, params?: I18NGetI18NData$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDataDto>> {
  const rb = new RequestBuilder(rootUrl, i18NGetI18NData.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<I18NDataDto>;
    })
  );
}

i18NGetI18NData.PATH = '/api/i18n/translations';
